import { createActionGroup, emptyProps } from '@ngrx/store';

export const appActions = createActionGroup({
    source: 'App',
    events: {
        // Wipe every feature slice back to its initial state (logout / user switch).
        // Tokens live in CredentialsService (not NgRx), so this does not end the session.
        Reset: emptyProps(),
    },
});
